import { Component, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { Pagination } from 'src/app/shared/models/pagination.model';
import {
  TransferMode,
  WithdrawModel,
  WithdrawRialStatus
} from 'src/app/shared/models/withdraw.model';
import { User } from 'src/app/shared/models/user.model';
import { Currency } from 'src/app/shared/models/currency.model';
import Swal from 'sweetalert2';
import { ReportService } from 'src/app/shared/service/report.service';
import { LazyLoadEvent } from 'primeng/api';
import { WithdrawRial } from 'src/app/shared/models/withdraw-rial.model';

@Component({
  selector: 'app-edit-pools-details',
  templateUrl: './withdraw-rial.component.html',
  styleUrls: ['./withdraw-rial.component.scss']
})
export class WithdrawRialComponent implements OnInit {
  sub = new SubSink();
  tableLoading = true;
  error: any = {};
  pagination: Pagination<WithdrawRial> = new Pagination<WithdrawRial>();
  loading = true;
  page = 1;
  limit = 15;
  includedUsers: User[] = [];
  selectedCurrency: Currency[] = [];
  Toast = Swal.mixin({
    toast: true,
    position: 'top',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener('mouseenter', Swal.stopTimer);
      toast.addEventListener('mouseleave', Swal.resumeTimer);
    }
  });
  status!: WithdrawRialStatus;
  WithdrawRialStatus = WithdrawRialStatus;

  constructor(private reportService: ReportService) {}

  changeRecordPerPageLimit(limit: number): void {
    this.limit = limit;
    this.getDepositList({
      first: 0,
      rows: limit
    });
  }

  copy(text: string, alert: string): void {
    navigator.clipboard.writeText(text);
    this.Toast.fire({ icon: 'success', text: alert });
  }

  getDepositList(event: LazyLoadEvent = {}): void {
    this.loading = true;
    if (event.first !== undefined && event.rows !== undefined) {
      this.page = event?.first / this.limit + 1;
    }
    const userIds = this.includedUsers.map((user) => user.id);
    this.reportService
      .getRialWithdrawList(userIds, this.page, event.rows, this.status)
      .subscribe((pagination) => {
        this.pagination = pagination;
        this.loading = false;
      });
  }

  ngOnInit(): void {}
}
